/* globals */

import httpClient from './lib/httpClient'

export const getOwners = async (payload) => {
  const endpoint = '/api/Owner/search/?companyId=' + payload.companyId + '&pageSize=' + payload.pageSize + '&pageNumber=' + payload.page + '&name=' + payload.name + '&surname=' + payload.surname + '&email=' + payload.email + '&mobile=' + payload.mobile + '&microChipNo=' + payload.microChipNo
  return httpClient.get(endpoint, payload)
}

export const getOwnerCertificate = async (petId) => {
  const endpoint = '/api/Owner/ownerCertificate/?petId=' + petId
  return httpClient.get(endpoint)
}

export const insertOwner = async (companyId, payload) => {
  const endpoint = '/api/Owner/insert/?companyId=' + companyId
  return httpClient.post(endpoint, payload)
}

export const updateOwner = async (payload) => {
  const endpoint = '/api/Owner/update'
  return httpClient.post(endpoint, payload)
}

export default {
  getOwners,
  insertOwner,
  updateOwner,
  getOwnerCertificate
}
